import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "about" */ './views/Home.vue'),
        meta: {
            title: '首页',
            isLogin: true
        }
    },
    {
        path: '/auth',
        name: 'Auth',
        component: () => import( /* webpackChunkName: "about" */ '@/views/user/auth'),
        meta: {
            title: '授权登录',
            isLogin: false
        }
    },
    {
        path: '/location',
        name: 'location',
        component: () => import(/* webpackChunkName: "about" */ '@/views/user/location.vue'),
        meta: {
            title: '获取定位',
            isLogin: true
        }
    },
    {
        path: '/shop',
        name: 'Shop',
        component: () => import(/* webpackChunkName: "about" */ '@/views/shop/index'),
        meta: {
            title: '商户列表',
            isLogin: true
        }
    },
    {
        path: '/address',
        name: 'address',
        component: () => import(/* webpackChunkName: "about" */ '@/views/user/address'),
        meta: {
            title: '当前位置',
            isLogin: true
        }
    },
    {
        path: '/userAddress',
        name: 'userAddress',
        component: () => import(/* webpackChunkName: "about" */ '@/views/user/user_address'),
        meta: {
            title: '配送地址',
            isLogin: true
        }
    },
    {
        path: '/goods',
        name: 'Goods',
        props: true,
        component: () => import('@/views/goods/index.vue'),
        meta: {
            title: '店家首页',
            isLogin: true
        }
    },
    {
        path: '/goods_fast',
        name: 'GoodsFast',
        props: true,
        component: () => import('@/views/goods/fast'),
        meta: {
            title: '特惠早餐',
            isLogin: true
        }
    },
    {
        path: '/cart',
        name: 'Cart',
        props: true,
        component: () => import('@/views/goods/cart.vue'),
        meta: {
            title: '购物车',
            isLogin: true
        }
    },
    {
        path: '/place_order',
        name: 'place_order',
        props: true,
        component: () => import('@/views/shop/place_order'),
        meta: {
            title: '下单',
            isLogin: true
        }
    },
    {
        path: '/success',
        name: 'success',
        props: true,
        component: () => import('@/views/goods/success'),
        meta: {
            title: '支付成功',
            isLogin: true
        }
    },
    {
        path: '/order_success',
        name: 'success',
        props: true,
        component: () => import('@/views/order/success'),
        meta: {
            title: '支付成功',
            isLogin: true
        }
    },
    {
        path: '/order',
        name: 'Order',
        props: true,
        component: () => import('@/views/order/index'),
        meta: {
            title: '订单列表',
            isLogin: true
        }
    },
    {
        path: '/order_info',
        name: 'OrderInfo',
        props: true,
        component: () => import('@/views/order/order_info'),
        meta: {
            title: '支付状态',
            isLogin: true
        }
    },
    {
        path: '/reminder',
        name: 'Reminder',
        props: true,
        component: () => import('@/views/order/reminder'),
        meta: {
            title: '催单',
            isLogin: true
        }
    },
    {
        path: '/order_pay',
        name: 'OrderPay',
        props: true,
        component: () => import('@/views/order/order_pay'),
        meta: {
            title: '订单支付',
            isLogin: true
        }
    },
    {
        path: '/coupon',
        name: 'Coupon',
        props: true,
        component: () => import('@/views/user/coupon'),
        meta: {
            title: '领取优惠券',
            isLogin: true
        }
    },
    {
        path: '/dre',
        name: 'Dre',
        props: true,
        component: () => import('@/views/user/dre'),
        meta: {
            title: '佣金',
            isLogin: true
        }
    },
    {
        path: '/group_apply',
        name: 'Dre',
        props: true,
        component: () => import('@/views/user/group_apply'),
        meta: {
            title: '领取特惠',
            isLogin: true
        }
    }
  ]


//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export const createRouter = (routes = []) => new VueRouter({
    mode: 'history',
    base: '',
    scrollBehavior: () => ({
        y: 0
    }),
    routes
})

const router = createRouter(routes)

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
})

router.$addRoutes = (params) => {
  router.matcher  = createRouter(routes).matcher
  router.options.routes  =  routes
  router.addRoutes(params)

}

export default router
